export default "__VITE_ASSET__DB0nNC_t__"